import { useSearchParams } from 'react-router';
import { RiSegmentEvents } from '../constants';
import { resetPageSearchParam } from '@/utils/purge-search-params.util';
import { useAnalyticsContext } from '@/utils/analytics/AnalyticsContext';

type Option = { title: string; name: string };

type OptionWithSelected = Option & {
  selected: boolean;
};

export function useFilter(filterKey: string) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { track } = useAnalyticsContext();
  const getFilterOptions = (options: Option[]) => {
    const filterStr = searchParams.get(filterKey);

    if (!filterStr) {
      return options.map((option) => ({ ...option, selected: false }));
    }

    const filters = filterStr.split(',');

    return options.map((option) => ({
      ...option,
      selected: filters.includes(option.name),
    }));
  };

  const handleFilterChange = (options: OptionWithSelected[]) => {
    const filterType = filterKey === 'source' ? 'Policy Type' : filterKey;
    const selectedOptionNames = options
      .filter((option) => option.selected)
      .map((option) => option.name);

    track(RiSegmentEvents.RiApplicationTableFilterClick, {
      filterType,
      selectedOptions: selectedOptionNames,
    });

    setSearchParams((prevSearchParams) => {
      const selectedOptionNames = options
        .filter(({ selected }) => Boolean(selected))
        .map((option) => option.name);

      resetPageSearchParam(prevSearchParams);

      if (!selectedOptionNames.length) {
        prevSearchParams.delete(filterKey);

        return prevSearchParams;
      }

      prevSearchParams.set(filterKey, selectedOptionNames.join(','));

      return prevSearchParams;
    });
  };

  return {
    getFilterOptions,
    handleFilterChange,
  };
}
